import script from "./RevenueExpense.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueExpense.vue?vue&type=script&setup=true&lang=js"

import "./RevenueExpense.vue?vue&type=style&index=0&id=7926cc20&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7926cc20"]])

export default __exports__